import clsx from 'clsx';

interface MfaHeroProps {
  plain?: boolean;
  setup?: boolean;
  src: string;
}

export function MfaHero({ plain = false, setup = false, src }: MfaHeroProps) {
  return (
    <div className={clsx('MfaTotpDialog__hero', { 'MfaTotpDialog__hero--plain': plain })}>
      <img alt="" className={clsx('MfaTotpDialog__heroImg', { 'MfaTotpDialog__heroImg--setup': setup })} src={src} />
    </div>
  );
}
